import { helper } from "lib/helper";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  Container,
  Row,
  Input,
  Button,
  CardBody,
  Label,
  Col,
  FormGroup,
  Progress,
} from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";

const AttendanceOverview = ({creditData}) => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const [completedSessionPercentage, setCompletedSessionPercentage] = useState(0);
  const [remainingSession, setRemainingSession] = useState(0);
  const [expiryDate, setExpiryDate] = useState('');
  useEffect(() => {
    if(creditData?.data?.number_of_session > creditData?.data?.sessionCompleted) {
      let percent = Math.floor((creditData?.data?.sessionCompleted / creditData?.data?.number_of_session) * 100);
      let remaining = creditData?.data?.number_of_session - creditData?.data?.sessionCompleted;
      setRemainingSession(remaining);
      setCompletedSessionPercentage(percent);
      const currentDate = moment();
      const futureDate = currentDate.add(5, 'days');
      const formattedDate = futureDate.format('YYYY-MM-DD');
      setExpiryDate(formattedDate);
    } else {
      setCompletedSessionPercentage(100);
      setRemainingSession(0);
    }
  }, [])

  return (
    <>
      <Container>
        {!isLoading && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">Attendance Overview</h3>
                  <Col md={6}>
                    <Button
                      style={{ float: "right",backgroundColor:"#080278",color:"white",border:"none" }}
                      color="primary"
                      type="submit"
                      to="/admin/creditmapping/creditmapping-view/tutors-replacement"
                      tag={Link}
                     
                    >
                      Replace Tutors
                    </Button>
                  </Col>
                </CardHeader>
                <CardBody>
                  <div >
                    <Row>
                      <Col md={5}>
                        <FormGroup>
                          <Label for="exampleEmail">
                            {" "}
                            No. Of Sessions Completed {creditData?.data?.sessionCompleted}/{creditData?.data?.number_of_session}
                          </Label>
                          <Progress
                            className="my-2"
                            value={completedSessionPercentage}
                            style={{ height: "25px" }}
                          >
                            {completedSessionPercentage}%
                          </Progress>
                        </FormGroup>
                      </Col>
                      <Col md={2}></Col>

                      <Col md={5}>
                        <FormGroup>
                          <Label for="exampleEmail"> Remaining Sessions</Label>
                          <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                            {remainingSession}
                          </p>
                        </FormGroup>
                      </Col>
                    </Row>

             

                    <Row>
                      <Col
                        md={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <p
                          style={{
                            border: "2px solid black",
                            padding: "20px",
                          }}
                        >
                          <spna>
                            <i
                              class="fa-solid fa-triangle-exclamation"
                              style={{ color: "red", fontSize: "20px" }}
                            ></i>
                          </spna>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              marginLeft: "20px",
                            }}
                          >
                            Your Class Cycle will Expire in {remainingSession} Days
                          </span>
                        </p>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </div>
          </Row>
        )}
      </Container>
    </>
  );
};

export default AttendanceOverview;
